<template>
  <div class="main-wrapper">
    <div class="background-overlay">
      <div class="content-container" style="position: relative;">
        <button class="contactButton btnCls" onclick="window.location.href='/login';">
  Yönetici Girişi
  <div class="iconButton" >
    <svg
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none"></path>
      <path
        d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
        fill="currentColor"
      ></path>
    </svg>
  </div>
</button>
     <!-- <a href="/login" class="admin-btn apply-btn" style="position: absolute;right: 15px; top: 5px;">Yönetici Girişi</a> -->
             <header class="page-header" style="display: block;">
          <h1 class="page-title">ANKETLER</h1>
          <div class="search-box">
            <span class="search-icon">🔍</span>
            <input type="text" v-model="searchQuery" placeholder="Anket ismine göre ara..." class="custom-input" />
          </div> 
        </header>
       


        <main class="anket-grid" style="overflow-y: scroll;">
          <div v-for="anket in filteredAnkets" :key="anket.formId" class="glass-card">
            <div class="card-header">
              <span class="card-icon">📄</span>
              <h2 class="anket-name">{{ anket.name }}</h2>
            </div>

            <div class="card-body">
                    <div class="date-row">
                <span class="icon">❖</span>
                <p><strong>Birim:</strong> {{ anket.birim }}</p>
              </div>
              <div class="date-row">
                <span class="icon">📅</span>
                <p><strong>Başlangıç:</strong> {{ anket.baslamaTarihi }}</p>
              </div>
              <div class="date-row">
                <span class="icon">🏁</span>
                <p><strong>Bitiş:</strong> {{ anket.bitisTarihi }}</p>
              </div>
            </div>

            <div class="card-footer">

              <a v-if="anket.loginGiris"  :href="'/login/'+anket.formId" class="apply-btn">Hemen Başvur</a>
              <a v-else  :href="'/formview/'+anket.formId" class="apply-btn">Hemen Başvur</a>
              <!-- <button type="" class="apply-btn">Hemen Başvur</button> -->
            </div>
          </div>
        </main>

      </div>
    </div>
  </div>
</template>

<style scoped>
/* Genel Yapı */
.main-wrapper {
  min-height: 100vh;
  width: 100%;
  background: url('../assets/amasya-universitesi-rektorlugunden_m.jpg') no-repeat center center fixed;
  background-size: cover;
}

.background-overlay {
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  /* Karartma */
  padding: 35px 20px;
  overflow-y: auto;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Başlık ve Arama */
.page-header {
  text-align: center;
  margin-bottom: 50px;
  margin-top: 5px;
}

.page-title {
  color: white;
  font-size: 3rem;
  letter-spacing: 4px;
  margin-bottom: 20px;
  font-weight: 800;
}

.search-box {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
}

.custom-input {
  width: 100%;
  padding: 15px 20px 15px 45px;
  border-radius: 50px;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  outline: none;
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

/* Grid ve Kartlar */
.anket-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 25px;
  color: white;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.glass-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.18);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.anket-name {
  font-size: 1.25rem;
  font-weight: 600;
}

.card-body {
  flex-grow: 1;
  margin-bottom: 20px;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  margin-top: 8px;
  opacity: 0.9;
}

/* Buton */
.apply-btn {
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid white;
  background: transparent;
  color: white;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.apply-btn:hover {
  background: white;
  color: #333;
}

/* Mobil Uyumluluk */
@media (max-width: 600px) {
  .page-title {
    font-size: 2rem;
  }

  .anket-grid {
    grid-template-columns: 1fr;
  }

  .btnCls{
position: absolute;
right: 15px; 
top: 5px;
  }
}




/*Button Tasarımı */
.contactButton {
  background: #7079f0;
  color: white;
  font-family: inherit;
  padding: 0.45em;
  padding-left: 1em;
  font-size: 17px;
  font-weight: 500;
  border-radius: 0.9em;
  border: none;
  cursor: pointer;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  box-shadow: inset 0 0 1.6em -0.6em #714da6;
  overflow: hidden;
  position: relative;
  height: 2.8em;
  padding-right: 3em;
}

.iconButton {
  margin-left: 1em;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.2em;
  width: 2.2em;
  border-radius: 0.7em;
  box-shadow: 0.1em 0.1em 0.6em 0.2em #7a8cf3;
  right: 0.3em;
  transition: all 0.3s;
}

.contactButton:hover {
  transform: translate(-0.05em, -0.05em);
  box-shadow: 0.15em 0.15em #5566c2;
}

.contactButton:active {
  transform: translate(0.05em, 0.05em);
  box-shadow: 0.05em 0.05em #5566c2;
}

</style>

<script>
import FormService from '@/services/FormService'; 
export default {
  name: "AktifAnketler",
  data() {
    return {
      searchQuery: '',
      ankets: [
        //{ formId: 1, name: 'Öğrenci Memnuniyet Anketi', baslamaTarihi: '01.10.2024', bitisTarihi: '30.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        //{ formId: 2, name: 'Yemekhane Değerlendirme', baslamaTarihi: '05.10.2024', bitisTarihi: '15.10.2024' },
        // Diğer veriler...
      ]
    }
  },
    created() {
    // this.validate()
    this.loadAnkets();

  },
  methods: {
    loadAnkets() {
      FormService.listCanliAnketFormlari().then((result) => {
        this.ankets = result.data;
      }).catch((err) => {

      });
    },
  },
  computed: {
    filteredAnkets() {
      return this.ankets.filter(anket =>
        anket.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  }
}
</script>